import { createAction, props } from '@ngrx/store';
import { ApplicationLogin } from '../authentication/models/application-login.interface';

export const appInitialized = createAction('[App Start] Initialized');

export const unverifiedSessionFound = createAction('[App Start] Unverified Session Found');

export const authenticationVerificationSuccess = createAction(
   '[App Start] Authentication Verification Success',
   props<{ loginResult: ApplicationLogin }>()
);

export const newAppVersionLoaded = createAction(
   '[App Start] New Application Version Loaded',
   props<{ oldVersion: string | null; newVersion: string }>()
);

export const authenticationVerificationFailure = createAction(
   '[App Start] Authentication Verification Failure',
   props<{ error: any }>()
);
